import { Button, Text } from "components/commons";
import { dateTimeFormatV3, formatAmount } from "utils";
import styles from "../cash-noncash.module.scss";
import locale from "localization/en";

export const bankDepositMapper = ({ val, onClickViewSlip }) => {
  const { bankDepositId, depositedAt, amount, type, remarks, imageUrl } = val;
  return {
    depositId: (
      <>
        <Text className={styles.content}>{bankDepositId ?? ""}</Text>
      </>
    ),
    dateAndTime: (
      <>
        <Text className={styles.content}>{dateTimeFormatV3(depositedAt ?? "")}</Text>
      </>
    ),
    amount: (
      <>
        <Text className={styles.content}>{formatAmount(amount ?? 0)}</Text>
      </>
    ),
    depositType: (
      <>
        <Text className={styles.content}>{type ?? ""}</Text>
      </>
    ),
    remarks: (
      <>
        <Text className={styles.content}>{remarks ?? ""}</Text>
      </>
    ),
    slipPreview: (
      <>
        <Button
          style={{ textDecoration: "none", background: !imageUrl ? "none" : undefined }}
          link
          onClick={() => onClickViewSlip(imageUrl)}
          disabled={!imageUrl}
        >
          {imageUrl ? (
            locale.view
          ) : (
            <>
              <Text className={styles.content}>{"--"}</Text>
            </>
          )}
        </Button>
      </>
    ),
  };
};
